<template>
  <div class="flex flex-col gap-6">
    <section class="w-full bg-bgr p-4 border border-bgr-300 rounded-lg">
      <h4 class="text-xl leading-6 font-semibold mb-2">
        {{ $t(`${trPrefixFilter}title`) }}
      </h4>

      <p class="text-base mb-2">
        {{ $t(`${trPrefixFilter}description`) }}
      </p>

      <ul class="list-disc text-base pl-6 mb-2">
        <li>{{ $t(`${trPrefixFilter}hintDates`) }}</li>
        <li>{{ $t(`${trPrefixFilter}hintLocations`) }}</li>
        <li>{{ $t(`${trPrefixFilter}hintFilters`) }}</li>
      </ul>

      <RedesignFilterSelected v-model="model" />
    </section>

    <section v-for="{ key, destination, request, result } in alternatives" :key>
      <h3
        v-track:impression="{
          'search:zeroResultsBannerDisplayed': [],
          'search:results': [destination, request, result.docs.length],
          'ecommerce:viewItemList': [result.docs, destination],
        }"
        class="mb-6 p-4 border border-bgr-300 rounded-lg text-xl font-semibold leading-6"
      >
        {{ $t(`${trPrefixArea}noResultsRecommender.${key}`) }}
      </h3>
      <RedesignSearchAreaResults
        :items="result.docs"
        :trip
        :loading="isPending"
      />
    </section>
  </div>
</template>

<script setup lang="ts">
const trPrefixArea = 'www.components.views.search.area.'
const trPrefixFilter = 'www.components.views.search.filter.noResults.'

const model = defineModel<SearchState>({ required: true })

const trip = computed(() => getTripParamsFromState(model.value))

const { data: alternatives, isPending } = useSearchAlternativesQuery(() =>
  mapSearchStateToSearchApiParams(model.value),
)
</script>
